import { render, staticRenderFns } from "./ConfirmTransferStock.vue?vue&type=template&id=07afcd9e&"
import script from "./ConfirmTransferStock.vue?vue&type=script&lang=js&"
export * from "./ConfirmTransferStock.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmTransferStock.vue?vue&type=style&index=0&id=07afcd9e&prod&lang=css&"
import style1 from "./ConfirmTransferStock.vue?vue&type=style&index=1&id=07afcd9e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports